import { ApolloProviderApiDataAccess } from "@package/ui-apollo-components";
import { AppContainer } from "@package/ui-app";
import { ErrorBoundaryAirbrake } from "@package/ui-components";
import { ConfigApp } from "@package/ui-config";
import { Provider } from "react-redux";
import { CMS_APP_ENVIRONMENT } from "../constants/contants";
import { store } from "../store/store";
import { AnalyticsOverviewBar } from "./AnalyticsOverviewBar/AnalyticsOverviewBar";
import { ContentSection } from "./Content/ContentSection";
import { Sidebar } from "./Sidebar/Sidebar";
const {
  ENV_VAR_AUTH0_AUDIENCE,
  ENV_VAR_AUTH0_CLIENT_ID,
  ENV_VAR_AUTH0_DOMAIN,
  ENV_VAR_AUTH0_REDIRECT_URI,
  ENV_VAR_API_URI_BASE,
  ENV_VAR_API_ANALYTICS_URI_BASE,
  ENV_VAR_AIRBRAKE_PROJECT_ID,
  ENV_VAR_AIRBRAKE_PROJECT_KEY,
} = import.meta.env;

function Body() {
  return (
    <ApolloProviderApiDataAccess app={ConfigApp.cms}>
      <div className="flex grow min-h-0 min-w-0">
        <div className="flex-0">
          <Sidebar />
        </div>
        <div className="grow flex flex-col min-h-0 min-w-0 overflow-y-auto bg-brand-paper border-l border-brand-line border-solid pb-4">
          <AnalyticsOverviewBar />
          <ContentSection />
        </div>
      </div>
    </ApolloProviderApiDataAccess>
  );
}

export function App() {
  return (
    <ErrorBoundaryAirbrake
      projectId={ENV_VAR_AIRBRAKE_PROJECT_ID}
      projectKey={ENV_VAR_AIRBRAKE_PROJECT_KEY}
    >
      <AppContainer
        auth={{
          authorizationParams: {
            audience: ENV_VAR_AUTH0_AUDIENCE,
            redirect_uri: ENV_VAR_AUTH0_REDIRECT_URI,
          },
          clientId: ENV_VAR_AUTH0_CLIENT_ID,
          domain: ENV_VAR_AUTH0_DOMAIN,
        }}
        config={{
          apollo: {
            name: "panoscape-cms",
          },
          app: ConfigApp.cms,
          baseUrlApi: ENV_VAR_API_URI_BASE,
          baseUrlApiAnalytics: ENV_VAR_API_ANALYTICS_URI_BASE,
          environment: CMS_APP_ENVIRONMENT,
        }}
      >
        <Provider store={store}>
          <div className="flex flex-col h-full">
            <Body />
          </div>
        </Provider>
      </AppContainer>
    </ErrorBoundaryAirbrake>
  );
}
